import httpCommon from "../../../shared/services/http-common"

export type BadgeExp = {
    explication: string
}

class BadgeService {
    async getBadgeExp() {
        return httpCommon.get(`${process.env.REACT_APP_API_ROOT}/getBadgeExp`)
    }

    async createBadgeExp(badgeExpData: BadgeExp) {
        try {
            const badgeExplication = await this.getBadgeExp();
            console.log(`BadgeExplication get: ${JSON.stringify(badgeExplication)}`)
            console.log(`Process env: ${process.env.REACT_APP_API_ROOT}`)


            if (badgeExplication.data.data.length === 0) {
                return httpCommon.post(`${process.env.REACT_APP_API_ROOT}/createBadgeExp`, badgeExpData)
            } else {
                return this.updateBadgeExp(badgeExplication.data.data[0]._id, badgeExpData)
            }
        }
        catch (e) {
            console.error(e)
        }
    }

    async deleteBadgeExp(id: string) {
        try {
            if (id) {
                return httpCommon.delete(`${process.env.REACT_APP_API_ROOT}/deleteBadgeExp/${id}`)
            }
        }
        catch (e) {
            console.error(e)
        }
    }

    async updateBadgeExp(id: string, badgeData: BadgeExp) {
        try {
            return httpCommon.put(`${process.env.REACT_APP_API_ROOT}/updateBadgeExp/${id}`, badgeData)
        } catch (e) {
            console.error(e)
        }
    }
}

const badgeService = new BadgeService()
export default badgeService